export enum SpotCheckTopic {
	ACCESSIBILITY = 'ACCESSIBILITY',
	SPELLING = 'SPELLING',
	PERFORMANCE = 'PERFORMANCE'
}
